var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { canApproveHours, canDenyHours } from '../../../../backend/utils/shiftStateUtils';
import { CopyButton } from '../../../../ui/components/CopyButton';
import { OigStatusChip } from '../../../../ui/features/shift-details/components/OigStatusChip';
import { AdminParticipantFullNameRenderer } from '../../../../ui/features/shift-roster-table/components/AdminParticipantFullNameRenderer';
import { HoursActions } from '../../../../ui/features/shift-roster-table/time-tracking-table-admin/HoursActions';
import { TimeTrackingStatus } from '../../../../ui/features/shift-roster-table/TimeTrackingStatus';
import { approveHoursDialog } from '../../../../ui/features/shift-roster-table/utils/approveHoursDialog';
import { denyHoursDialog } from '../../../../ui/features/shift-roster-table/utils/denyHoursDialog';
import { useShiftParticipantActions } from '../../../../ui/features/shift/hooks/useShiftParticipantActions';
import { useMissionsTranslation } from '../../../../ui/hooks';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';
export function useAdminShiftParticipantsTableColumns({ fetchReload, }) {
    const { t } = useMissionsTranslation();
    const { handleAddHours, handleDenyHours, handleApproveHours } = useShiftParticipantActions();
    return [
        {
            headerLabel: t('shifts.rosterTable.participantFullName'),
            cellFunction: (row) => React.createElement(AdminParticipantFullNameRenderer, { row: row }),
            tableCellSx: { maxWidth: 200 },
        },
        {
            headerLabel: t('shifts.rosterTable.positionName'),
            cellFunction: (row) => {
                return (React.createElement(Stack, { direction: 'row', spacing: 1, alignItems: 'center' },
                    React.createElement(Typography, { variant: 'body2', color: 'textSecondary' }, row.columns.positionName),
                    React.createElement(CopyButton, { value: row.columns.positionName, successMessage: t('shifts.adminTimeTracking.copy.success') })));
            },
        },
        {
            headerLabel: t('shifts.rosterTable.hours'),
            cellFunction: (row) => {
                return (React.createElement(TimeTrackingStatus, { status: row.columns.hoursStatus, time: row.columns.hours }));
            },
            tableCellSx: { maxWidth: 149 },
        },
        {
            headerLabel: t('shifts.rosterTable.hoursStatus'),
            cellFunction: (row) => {
                return (React.createElement(Box, null,
                    React.createElement(HoursActions, { status: row.columns.hoursStatus, shiftId: row.columns.shiftId, shiftStartTime: row.columns.shiftStartTime, shiftStopTime: row.columns.shiftStopTime, participantShiftStartTime: row.columns.hoursFrom, participantShiftStopTime: row.columns.hoursTo, participationId: row.id, volunteerName: row.columns.participantFullName, missionOrganizationSharing: row.columns.organizationSharing, onAddHours: (params) => __awaiter(this, void 0, void 0, function* () {
                            yield handleAddHours(params);
                            yield fetchReload();
                        }) })));
            },
            tableCellSx: { maxWidth: 97 },
        },
        {
            headerLabel: t('shifts.rosterTable.oigStatus'),
            cellFunction: (row) => { var _a; return React.createElement(OigStatusChip, { oigStatus: (_a = row.columns.accountOigStatus) !== null && _a !== void 0 ? _a : 'notVerified' }); },
        },
        {
            headerLabel: t('shifts.rosterTable.actions'),
            cellFunction: (row) => {
                const showDeny = canDenyHours(row);
                const showApprove = canApproveHours(row);
                return (React.createElement(Box, { sx: {
                        display: 'flex',
                        gap: 1,
                        flexDirection: { xs: 'column', lg: 'row' },
                        justifyContent: 'end',
                    } },
                    showDeny && (React.createElement(Button, { startIcon: React.createElement(CloseIcon, null), onClick: (event) => {
                            event.stopPropagation();
                            denyHoursDialog({ row, handleDenyHours, t, fetchReload });
                        }, "data-test": 'deny-button', variant: 'outlined', size: 'small' }, t('timeTracking.denyButtonLabel'))),
                    showApprove && (React.createElement(Button, { startIcon: React.createElement(CheckIcon, null), onClick: (event) => {
                            event.stopPropagation();
                            approveHoursDialog({ rows: [row], t, fetchReload, handleApproveHours });
                        }, variant: 'contained', size: 'small', "data-test": 'approve-hours' }, t('shifts.adminTimeTracking.approveHours')))));
            },
        },
    ];
}
